import { config } from "@repo/config";
import { LoginForm } from "@saas/auth/components/LoginForm";
import { createFileRoute } from "@tanstack/react-router";

// Same form as the home page, which is the one indexed. This URL carries
// ?redirectTo= and stays out of search (the root's noindex applies).
export const Route = createFileRoute("/_auth/login")({
	head: () => ({
		meta: [{ title: `Sign in - ${config.appName}` }],
	}),
	component: LoginForm,
});
